/* Keep the app container outside the cart form and before purchase guidance.
 * Moving the original node preserves Wishlist Hero's handlers and state. */
if (!customElements.get('be-product-wishlist')) {
  customElements.define('be-product-wishlist', class extends HTMLElement {
    connectedCallback() {
      const info = this.closest('.product__info-container');
      const form = info?.querySelector('product-form');
      if (!form) return;
      if (form.nextElementSibling !== this) {
        form.after(this);
        return;
      }
      const relocate = () => {
        info.querySelectorAll('.wishlisthero-product-page-button-container').forEach((container) => {
          if (!this.contains(container) && container.querySelector('button')) {
            this.querySelectorAll('#wishlisthero-product-page-button-container').forEach((placeholder) => {
              if (!placeholder.querySelector('button')) placeholder.remove();
            });
            this.append(container);
          }
        });
      };
      this.observer?.disconnect();
      this.observer = new MutationObserver(relocate);
      this.observer.observe(info, { childList: true, subtree: true });
      relocate();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

/* Keep the app's original review nodes/listeners; only relocate the summary.
 * The slot is outside the variant-replaced price container. Trustoo can insert
 * its summary asynchronously, including after a section refresh. */
if (!customElements.get('be-product-reviews')) {
  customElements.define('be-product-reviews', class extends HTMLElement {
    connectedCallback() {
      const info = this.closest('.product__info-container');
      if (!info) return;
      const relocate = () => {
        info.querySelectorAll('.vstar-star, .rating-wrapper').forEach((review) => {
          if (!this.contains(review)) this.append(review);
        });
      };
      this.observer = new MutationObserver(relocate);
      this.observer.observe(info, { childList: true, subtree: true });
      relocate();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
